// lib/global-events.ts
import React from 'react';

// --- Quota Error Events ---

export interface QuotaErrorPayload {
  message: string;
}

export const QUOTA_ERROR_EVENT = 'quota-error';

export function dispatchQuotaError(payload: QuotaErrorPayload) {
  const event = new CustomEvent(QUOTA_ERROR_EVENT, { detail: payload });
  window.dispatchEvent(event);
}

export function useQuotaErrorListener(onError: (payload: QuotaErrorPayload) => void) {
  React.useEffect(() => {
    const handleEvent = (event: Event) => {
      const customEvent = event as CustomEvent<QuotaErrorPayload>;
      if (customEvent.detail) {
        onError(customEvent.detail);
      }
    };

    window.addEventListener(QUOTA_ERROR_EVENT, handleEvent);

    return () => {
      window.removeEventListener(QUOTA_ERROR_EVENT, handleEvent);
    };
  }, [onError]);
}
